import React from "react";
import partner1 from "../assets/BigMinds.webp";
import partner2 from "../assets/TechBairn.webp";
import partner3 from "../assets/Amiker.webp";
import partner4 from "../assets/Travysys.webp";
import partner5 from "../assets/BugHight.webp";
import partner6 from "../assets/Kanu.webp";

const OurPartners = React.memo(() => {
    const partners = [partner1, partner2, partner3, partner4, partner5, partner6];
    const partnerList = [...partners, ...partners];
  
    return (
      <section className="our-partners">
        <div className="partners-content">
          <h2>Brands that Trust Us!</h2>
          <div className="partners-carousel">
            <div className="partners-track">
              {partnerList.map((logo, index) => (
                <div key={index} className="partner-logo">
                  <img
                    src={logo}
                    srcSet={`
                      ${logo} 320w,
                      ${logo} 480w,
                      ${logo} 800w
                    `}
                    sizes="(max-width: 320px) 280px, (max-width: 480px) 440px, 800px"
                    alt={`Partner ${index + 1}`}
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  });
export default OurPartners; 